// removed by extract-text-webpack-plugin
module.exports = {"container":"root-module__container___q7OCb","fullScreenButton":"root-module__fullScreenButton___bYqeO","contentWrapper":"root-module__contentWrapper___vLROM"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/root/root.module.scss
// module id = 778
// module chunks = 0